import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as NotificationService from 'services/api/notification';
import { useSelector } from 'react-redux';

interface ICountry {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export interface VatReturnsReceivedListOutput {
  status: StateStatus;
  data: NotificationService.ReminderListData | null;
}

export const useGetVatReturnsReceivedList =
  (): VatReturnsReceivedListOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.VATRETURNS_RECEIVED_LIST_REDUCER]
          .VatReturnsReceivedList
    );
    return data;
  };

export const useGetUnreadNotificationCount = (): number => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.VATRETURNS_RECEIVED_LIST_REDUCER]
        .unreadNotificationCount.data
  );
  return data;
};

export const useGetMemberStateExcludeCyprusCountries = (): Array<ICountry> => {
  const data = useSelector(
    (state: any) =>
      state[ReducerKeys.VATRETURNS_RECEIVED_LIST_REDUCER]
        .memberStateExcludeCyprusList.data
  );
  return data;
};
